import { defineMessages } from 'react-intl';

export default {
  pages: {
    signup: {
      registration: {
        components: {
          email: defineMessages({
            label: {
              id: 'pages.signup.registration.components.email.label',
              defaultMessage: 'Email address:',
            },
            labelShort: {
              id: 'pages.signup.registration.components.email.labelShort',
              defaultMessage: 'Email',
            },
            changeAddress: {
              id: 'pages.signup.registration.components.email.changeAddress',
              defaultMessage: 'New email address:',
            },
            changeAddressShort: {
              id: 'pages.signup.registration.components.email.changeAddressShort',
              defaultMessage: 'New email',
            },
            invalid: {
              id: 'pages.signup.registration.components.email.invalid',
              defaultMessage: 'Email address is incorrect. Please try again.',
            },
            taken: {
              id: 'pages.signup.registration.components.email.taken',
              defaultMessage: 'This email address is already registered. Please choose another.',
            },
            empty: {
              id: 'pages.signup.registration.components.email.empty',
              defaultMessage: 'Email address required',
            },
          }),
        },
      },
    },
  },
};
